<nav class="position-relative">
	<a data-testid="SUBSYS2_EDITTOOLS_ROTATE_BTN" class="nav-link" routerLinkActive="active" [class.active]="isRotate"
		[title]="labels().EDIT_TOOLS_COMPONENT_ROTATE" (click)="rotate()">
		<i class="material-icons-outlined">rotate_right</i>
	</a>
	<a data-testid="SUBSYS2_EDITTOOLS_CONTRAST_BTN" class="nav-link position-relative" routerLinkActive="active"
		[class.active]="isContrast" [title]="labels().EDIT_TOOLS_COMPONENT_CONTRAST" (click)="isContrast = !isContrast">
		<i class="material-icons-outlined">brightness_6</i>
		<div class="w-100" [ngbCollapse]="!isContrast" [horizontal]="true" [animation]="false" (shown)="initContrastValue()"
			(click)="$event.stopPropagation()" (keypress)="$event.stopPropagation()">
			<div class="slider-wrapper">
				<input id="contrastSlider" type="text" />
			</div>
		</div>
	</a>
	<a data-testid="SUBSYS2_EDITTOOLS_BRIGHTNESS_BTN" class="nav-link position-relative" routerLinkActive="active"
		[class.active]="isBrightness" [title]="labels().EDIT_TOOLS_COMPONENT_BRIGHTNESS"
		(click)="isBrightness = !isBrightness">
		<i class="material-icons-outlined">light_mode</i>
		<div class="w-100" [ngbCollapse]="!isBrightness" [horizontal]="true" [animation]="false"
			(shown)="initBrightnessValue()" (click)="$event.stopPropagation()" (keypress)="$event.stopPropagation()">
			<div class="slider-wrapper">
				<input id="brightnessSlider" type="text" />
			</div>
		</div>
	</a>
	<a data-testid="SUBSYS2_EDITTOOLS_RESET_BTN" class="nav-link" routerLinkActive="active" [class.disabled]="isRotate"
		[title]="labels().EDIT_TOOLS_COMPONENT_RESET" (click)="reset()">
		<i class="material-icons-outlined">restart_alt</i>
	</a>
</nav>